import { TestArtifact } from '../../enums/test-artifact.enum';

/**
 * The base model class
 */
export class BaseModel {
  /** The ID of the model */
  public _id: string;

  /** The date the model was creatd */
  public dateCreated: Date;

  /** The date the model was last modified */
  public dateModified: Date;

  /** Boolean indicating whether the model is a test artifact */
  public testArtifact?: boolean;

  /**
   * @param testArtifact - Enum indicating whether the model is a test artifact
   */

  constructor(testArtifact?: TestArtifact) {
    if (testArtifact === TestArtifact.true) {
      this.testArtifact = true;
    }
  }
}
